import { Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../constants/config";
import { StudentSidebar } from "../../Sidebar/student-sidebar";
import FeatureGuard from "../../components/FeatureGuard";
import FeeManagement from "../Student/Fee-Managment/StudentFeeManagement";
import LeaveApplication from "../Student/leave-application";
// Bus tracking replaced by mobile-tracking-2 redirect
import AnnouncementList from "../Common/AnnouncementList";
import MyProfile from "../Student/MyProfile";

export default function StudentDashboardRouter() {
  const [loading, setLoading] = useState(true);
  const [schoolSettings, setSchoolSettings] = useState(null);
  const token = localStorage.getItem("token");
  const canAccessStudentBusTracking =
    schoolSettings?.enableBusService?.enabled === true &&
    schoolSettings?.enableStudentBusService?.enabled === true;

  useEffect(() => {
    async function fetchSettings() {
      const token = localStorage.getItem("token");
      const userStr = localStorage.getItem("user");
      if (!token || !userStr) return;
      try {
        const user = JSON.parse(userStr);
        let schoolId = user?.school && (typeof user.school === "object" ? user.school._id : user.school);
        if (!schoolId) {
          try {
            const profileRes = await axiosInstance.get(API_ENDPOINTS.usersProfile);
            const profileUser = profileRes.data?.data?.user;
            schoolId =
              profileUser?.school &&
              (typeof profileUser.school === "object" ? profileUser.school._id : profileUser.school);
          } catch (profileError) {
            console.error("Failed to fetch user profile for school ID:", profileError);
          }
        }
        if (!schoolId) {
          console.error("Missing school id in user data");
          return;
        }
        setLoading(true);
        const res = await axiosInstance.get(`${API_ENDPOINTS.schoolFeatures(schoolId)}?t=${Date.now()}`);
        setSchoolSettings(res.data?.data || null);
      } catch (error) {
        console.error("Error fetching school settings:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchSettings();

    const handleWindowFocus = () => {
      fetchSettings();
    };
    window.addEventListener("focus", handleWindowFocus);

    return () => {
      window.removeEventListener("focus", handleWindowFocus);
    };
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        <span className="ml-2">Loading...</span>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<StudentSidebar schoolSettings={schoolSettings} />}>
        <Route index element={<Navigate to="/dashboard/fees" replace />} />
        <Route path="fees" element={<FeatureGuard feature="feeManagement"><FeeManagement /></FeatureGuard>} />
        <Route path="leave" element={<FeatureGuard feature="leave"><LeaveApplication /></FeatureGuard>} />
        <Route
          path="bustracking"
          element={<Navigate to="/mobile-tracking-2" replace />}
        />
        <Route path="announcements" element={<FeatureGuard feature="announcements"><AnnouncementList /></FeatureGuard>} />
        <Route path="profile" element={<MyProfile />} />
        <Route path="*" element={<Navigate to="/dashboard/fees" replace />} />
      </Route>
    </Routes>
  );
} 